import { createReducer } from "./functions";

import { PROPERTIES_SET_LIST } from '../types';

const initialState = {
  propertiesList: [],
  page: 0,
  pages: 0,
  pageSize: 10
}

const setPropertiesList = {
  [PROPERTIES_SET_LIST]: (state, action) => {
    const page = action.payload.hasOwnProperty("page")
    ? action.payload.page
    : state.page;
    const pages = action.payload.hasOwnProperty("pages")
      ? action.payload.pages
      : state.pages;
    let hasNext = true;

    if (page === 0 || page === pages)
      hasNext = false;
    return { ...state, propertiesList: action.payload.docs, page, pages, hasNext };
  }
}
const propertiesReducer = createReducer(initialState, {
  ...setPropertiesList
})

export default propertiesReducer;


// WEBPACK FOOTER //
// src/redux/reducers/propertiesReducer.js